// extracted by mini-css-extract-plugin
export default {"root":"content_root__tOSur","contentBlocks":"content_contentBlocks__SqzsJ","table":"content_table__sRhLO","row":"content_row__phvg7"};